@if (resultCount() !== null) {
  <span
    class="result-count"
    [class.positive]="(resultCount() ?? 0) > 0"
    [pTooltip]="tooltip() || ''"
    [tooltipDisabled]="!tooltip()"
    tooltipStyleClass="assignment-result-json-tooltip"
    tooltipPosition="left"
  >{{ resultCount() }}</span>
}
